import { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosInstance";
import ImageCarousel from "./ImageCarousel";
import SkeletonLoader from "./SkeletonLoader";

const getMoreImages = async (clientID, promoCode, promoId, AdminCRMDataURL) => {
    try {
        // Sending POST request to fetch promotion images
        const response = await axiosInstance.post(AdminCRMDataURL + "Loy_CRM_DownloadPromotionImages", {
            DATA: {
                CLIENT_ID: clientID,
                PROMO_CODE: promoCode,
                PROMO_ID: promoId,
            },
        });

        // Check if the response status is successful (assuming 'STATUS' is part of the response)
        if (response.data?.SUCCESS == "True") {
            return response.data; // Return the data if the status is successful
        } else {
            throw new Error("Failed to fetch images: " + response.data?.MESSAGE || "Unknown error");
        }
    } catch (error) {
        console.error("Error fetching images:", error);
        throw error; // Propagate the error for further handling
    }
};

const PromotionImageCarousel = ({ clientID, promoCode, promoId, AdminFileSrvURL, appSettings }) => {
    const { AdminCRMDataURL } = appSettings;
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                setLoading(true);
                const result = await getMoreImages(clientID, promoCode, promoId, AdminCRMDataURL);
                console.log(result.DATA, "images");
                setImages(result?.DATA || []); // Assuming result contains an `images` array
            } catch (error) {
                setError("Failed to load images");
            } finally {
                setLoading(false);
            }
        };

        fetchImages();
    }, [clientID, promoCode, promoId]);

    return (
        <div>
            {/* {loading && <SkeletonLoader />} */}
            {/* {error && <p>{error}</p>} */}
            {<ImageCarousel images={images} imageURL={AdminFileSrvURL} loading={loading} />}
        </div>
    );
};

export default PromotionImageCarousel;
